<template>
  <v-select
    :items="aparelhos"
    label="Aparelho"
    item-text="text"
    item-value="value"
    v-model="aparelhoSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroAparelho',
  data() {
    return {
      aparelhos: [
        {
          text: 'Todos',
          value: null
        },
        {
          text: 'Android',
          value: 'android'
        },
        {
          text: 'iOS',
          value: 'ios'
        },
        {
          text: 'WebApp',
          value: 'webapp'
        }
      ],
      aparelhoSelecionado: null
    }
  },
  watch: {
    aparelhoSelecionado() {
      this.$emit('filtrar-aparelho', {
        aparelho: this.aparelhoSelecionado
      })
    }
  }
}
</script>
